import Api from "./Api";

export default {
  getAllPurchasesList(payload) {
    let allPurchases = Api().post("Api_Expenses/getallPurchases.php", payload);
    return allPurchases;
  },

  getAllDocumentList(payload) {
    let allDocumentList = Api().post("Api_Master/documentUpload.php", payload);
    return allDocumentList;
  },

  getAllPendingReverseTallyList(payload) {
    // console.log("HIIIIIII >>>");
    let PendingReverseTallyCount = Api().post(
      "Api_Reports/reportsExcel_NewV3.php",
      payload,
    );
    return PendingReverseTallyCount;
  },

  uploadExcelFile(payload) {
    let uploadExcelDataMaster = Api().post(
      "uploadExcelDataMaster.php",
      payload,
    );
    return uploadExcelDataMaster;
  },

  async getAllCreditDebitNoteList(payload) {
    console.log("payload=>", payload);
    let CreditDebitNoteList = await Api().post(
      "Api_Common/viewAssignmentTrackDetails.php",
      payload,
    );
    return CreditDebitNoteList;
  },

  async getAllCurrencyList(payload) {
    let allCurrencyList = await Api().post(
      "Api_Master/viewAllCurrencyList.php",
      payload,
    );
    return allCurrencyList;
  },
  async getActivateStatus(payload) {
    let allActivateStatus = await Api().post(
      "Api_Master/activateAgent.php",
      payload,
    );
    return allActivateStatus;
  },
  async getAllAgentColoaderList() {
    let type_Size = {
      view: "jdjd",
    };
    let payload = JSON.stringify(type_Size);
    let allAgentColoaderList = await Api().post(
      "Api_FFSeaExport/getAgentColoaderListActive.php",
      payload,
    );
    return allAgentColoaderList;
  },

  getAllBranchList(payload) {
    if (!payload) {
      let type_Size = {
        filter: "BranchList",
      };

      let payload = JSON.stringify(type_Size);
    }
    let AllBranchList = Api().post(
      "Api_Common/viewAssignmentTrackDetails.php",
      payload,
    );
    return AllBranchList;
  },
  getAllMultiBranchList(payload) {
    // let type_Size = {
    //   filter: "MultiBranchList",
    // };
    // let payload = JSON.stringify(type_Size);
    let AllMultiBranchList = Api().post(
      "Api_Common/viewAssignmentTrackDetails.php",
      payload,
    );
    return AllMultiBranchList;
  },

  proceedCRDRPaymentDetails(payload) {
    let AllBranchList = Api().post(
      "Api_Common/viewAssignmentTrackDetails.php",
      payload,
    );
    return AllBranchList;
  },

  getAllProformaInvoice(payload) {
    let allProformaInvoice = Api().post(
      "Api_ProformaInvoices/getAllProformaInvoice.php",
      payload,
    );
    return allProformaInvoice;
  },

  getAllCommonMaster(payload) {
    let allProformaInvoice = Api().post(
      "Api_Master/getAllCommonMaster.php",
      payload,
    );
    return allProformaInvoice;
  },
  getDocumentTypeMaster(payload) {
    let allDocumentType = Api().post(
      "Api_Master/addDocumentType_VP.php",
      payload,
    );
    return allDocumentType;
  },
  getAllBL_List(payload) {
    let allBL_List = Api().post("Api_FFSeaExport/fetchBL-List.php", payload);
    return allBL_List;
  },

  getAllBLDash(payload) {
    let allDash = Api().post("Api_EmpDashboard/getDash.php", payload);
    return allDash;
  },

  getAllLedgerList(payload) {
    let allLedgerData = Api().post(
      "Api_ProformaInvoices/getAllProformaInvoice.php",
      payload,
    );
    return allLedgerData;
  },
  getAllBillingLocationList(payload) {
    let allBillingLocationList = Api().post(
      "Api_ProformaInvoices/getAllProformaInvoice.php",
      payload,
    );
    return allBillingLocationList;
  },
  getAllClientList(payload) {
    let allClientList = Api().post(
      "Api_ProformaInvoices/getAllProformaInvoice.php",
      payload,
    );
    return allClientList;
  },
  getAllLeadClientList(payload) {
    let allLeadClientList = Api().post("Lead/getAllEnqPricing.php", payload);
    return allLeadClientList;
  },

  getAllUserList(payload) {
    let allUserList = Api().post(
      "Api_ProformaInvoices/getAllcommon.php",
      payload,
    );
    return allUserList;
  },

  getAllUnitList(payload) {
    let allUnitList = Api().post(
      "Api_ProformaInvoices/getAllProformaInvoice.php",
      payload,
    );
    return allUnitList;
  },
  getAllSplitedOrMergedContainersList(payload) {
    let allSplitedOrMergedContainersList = Api().post(
      "Api_ProformaInvoices/getAllProformaInvoice.php",
      payload,
    );
    return allSplitedOrMergedContainersList;
  },
  getAllFFDashboardData(payload) {
    let allFFDashboardData = Api().post(
      "Api_Common/getFFSeaExpDashClientSline.php",
      payload,
    );
    return allFFDashboardData;
  },
  getAllManifestationDetails(payload) {
    let allMainfestationDetails = Api().post(
      "Api_Expenses/getCommonMainfestationDetails.php",
      payload,
    );
    return allMainfestationDetails;
  },
  getAllPreAlertDetails(payload) {
    let getAllPreAlertDetails = Api().post(
      "Api_ProformaInvoices/getAllcommon.php",
      payload,
    );
    return getAllPreAlertDetails;
  },

  //Shreshth Added New Services For Excel
  getAllMainReport(payload) {
    // console.log("HIIIIIII >>>");
    let AllMainReport = Api().post(
      "Api_MainReport/reportsMainExcel.php",
      payload,
    );
    return AllMainReport;
  },
  getTPTDashreportsExcel(payload) {
    // console.log("HIIIIIII >>>");
    let AllTPTDashReport = Api().post(
      "Api_Common/getTPTDashreportsExcel.php",
      payload,
    );
    return AllTPTDashReport;
  },
  getCustomIdelVehicleListExcel(payload) {
    // console.log("HIIIIIII >>>");
    let AllTPTDashReport = Api().post(
      "Api_Common/getCustomIdelVehicleListExcel.php",
      payload,
    );
    return AllTPTDashReport;
  },
  getAgentColoderExcel(payload) {
    // console.log("HIIIIIII >>>");
    let AllTPTDashReport = Api().post(
      "Api_Reports/reportsAgentColoderExcel.php",
      payload,
    );
    return AllTPTDashReport;
  },

  getAllExpenseList(payload) {
    let AllTPTDashReport = Api().post(
      "Api_TallyBilling/getTallyExpense.php",
      payload,
    );
    return AllTPTDashReport;
  },

  getAllJobList(payload) {
    let AllJobList = Api().post("Api_Common/getJobPendency.php", payload);
    return AllJobList;
  },
  getAllUserDetails(payload) {
    let AllUserDetails = Api().post("Api_Master/getUserDetails.php", payload);
    return AllUserDetails;
  },

  getCheckBLDetails(payload) {
    let allDash = Api().post("Api_Common/getDataCheck.php", payload);
    return allDash;
  },
  getClientDetails(payload) {
    let allDash = Api().post("Api_Master/viewClientList.php", payload);
    return allDash;
  },
  removeSlineInvoice(payload) {
    let allPurchases = Api().post("Api_Common/getJobPendency.php", payload);
    return allPurchases;
  },

  getCommonSignedUrl(payload) {
    let response = Api().post(
      "getCommonSignedUrl.php", // Adjust path if necessary based on your proxy/API setup
      payload,
    );
    console.log("response getCommonSignedUrl=>", response);
    return response;
  },
};



// WEBPACK FOOTER //
// ./src/services/CommonService.js